interface GoldPriceResponse {
  price: number;
  timestamp: number;
  error?: string;
}

// Function to fetch current gold price
export async function getGoldPrice(): Promise<GoldPriceResponse> {
  try {
    const response = await fetch('https://gold-price-api.zaidazmi27.workers.dev');
    if (!response.ok) {
      throw new Error('Failed to fetch gold price');
    }
    const data = await response.json() as GoldPriceResponse;
    return data;
  } catch (error) {
    console.error('Error fetching gold price:', error);
    // Return a fallback price in case of error
    return {
      price: 85.31, // Default fallback price per gram
      timestamp: Date.now()
    };
  }
}

export const calculateGoldAmount = (bitcoinPrice: number, goldPricePerGram: number, timestamp: number) => {
  const totalUSD = bitcoinPrice;
  const gramsOfGold = totalUSD / goldPricePerGram;
  const kilosOfGold = gramsOfGold / 1000;
  
  return {
    grams: gramsOfGold,
    kilos: kilosOfGold,
    lastUpdated: timestamp
  };
};